<script>


let y
</script>

<svelte:window bind:scrollY={y}/>


<section>
  <div class="hero-banner">
    <h2>Nos réalisations</h2>
    <div class="hero-images">
      <div class="hero-outside">
        <img style="transform: translateY({-y * 0.2}px);" class="hero-outside-image" src="/realisation-hero.svg" alt="Un jolie extérieur">
      </div>
      <img class="hero-inside" src="/realisation-inside.svg" alt="Salle à manger, avec une belle table.">
    </div>
    <div class="inside-image">
      <div class="image">
        <img style="transform: translateY({-y * 0.2 + 150}px);" src="/realisation-inside-living.svg" alt="salon design">
      </div>
    </div>
    <div class="bottom-banner">
      <h3>Choisissez ce qui vous fait rêver !</h3>
      <div class="bottom-img-wrapper">
        <div class="bottom-img">
          <img class="bottom-first-img" src="/realisation-bottom-inside.svg" alt="intérieur">
        </div>
        <img class="bottom-second-img" src="/realisation-bottom-outside.svg" alt="extérieur">
      </div>
    </div>
  </div>

</section>

<style>

  .hero-banner{
    width: 100%;

    text-align: center;

    margin-top: 50px;
  }

  .hero-banner h2{
    text-transform: uppercase;
  }

  .hero-images{
    display: flex;
    flex-direction: column;
    align-items: center;

    position: relative;
  }

  .hero-outside{
    width: max(250px, 60%);

    margin: 17vw 0 479px 0;

    position: relative;

    z-index: -1;
  }

  .hero-outside-image{
    width: 100%;
  }

  .hero-outside::after{
    content: '';

    position: absolute;

    width: 100%;
    height: 100%;

    background: #FCC6C6;

    top: 0;
    left: 0;

    transform: translate(-15%, -15%);

    z-index: -1;
  }

  .hero-inside{
    position: absolute;

    bottom: 0;
    left: 0;

    width: 289px;

    z-index: -1;
  }

  .inside-image{
    margin: 100px 0;

    width: 100%;

    display: flex;
    justify-content: flex-end;

    padding-right: 7vw;
  }

  .image{
    width: max(65vw, 250px);
    max-width: 1000px;

    position: relative;
  }

  .image::after{
    content: '';

    position: absolute;

    width: 100%;
    height: 100%;

    background: #D1EFED;

    top: 0;
    left: 0;

    transform: translate(-15%, 23%);

    z-index: -1;
  }

  .bottom-banner{
    margin-top: max(100px, 20vw);
  }

  .bottom-banner h3{
    font-size: 2rem;

    padding: 30px;
  }
  
  .bottom-img-wrapper{
    position: relative;
  }

  .inside-image img{
    width: 100%;
  }

  .bottom-img{
    width: 100%;

    background: #FBE4C1;

    padding: 50px 0 50px 0;

    margin-bottom: 50px;
  }

  .bottom-first-img{
    width: max(60%, 200px);
  }

  .bottom-second-img{
    width: max(40%, 150px);

    margin-bottom: 100px;
  }

  @media screen and (min-width: 650px){
    .hero-images{
      flex-direction: row;

      margin-top: 17vw;
      padding-left: 10vw;
    }
    .hero-inside{
      position: absolute;

      left: 100%;
      top: 0;

      transform: translateX(-100%);

      width: 25%;
      max-width: 500px;
    }
    .hero-outside{
    width: max(250px, 60%);
    max-width: 600px;

    margin: 0 20px 100px 20px;

    position: relative;
  }
  }

</style>